import Vue from 'vue'
import VueRouter from "vue-router";


import Index from '@/page/index';
import Post from '@/page/post';
import Essay from '@/page/essay';
import Search from '@/page/search';
import err404 from '@/page/error/404';
import err401 from '@/page/error/401';
import Iframe from '@/page/components/h-iframe';
import Account from '@/page/account/index';
import Rss from '@/page/rss/index';

Vue.use(VueRouter);

/**
 * 公共访问页面到 premission.js 增加地址
 * @type {VueRouter}
 */
const router = new VueRouter({
    routes: [
        {
            path: '/rss',
            component:Rss,
        },
        {
            path: '/account',
            component:Account,
        },
        {
            path: '/public',
            component:Iframe,
        },
        {
            path: '/search',
            component: Search,
        },
        {
            path: '/post',
            component: Post,
        },
        {
            path: '/essay',
            component: Essay,
        },
        {
            path: '/401',
            component: err401
        },
        {
            path: '/404',
            component: err404
        },
        {
            path: '/',
            component: Index,
        },
        { path: '*', component: err404 },
    ],
    //页面自动跳转到顶部
    /*scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            // 如果 savedPosition 存在，还原滚动位置
            return savedPosition;
        } else {
            // 否则，滚动到页面顶部
            return { x: 0, y: 0 };
        }
    },*/
    // mode: 'history',
});

export default router
